var _path, _path2, _path3, _path4, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "Application",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M9.02 42.6h7.762V59a2 2 0 0 1-2 2H9.02a2 2 0 0 1-2-2V44.6a2 2 0 0 1 2-2Z",
    className: "color546f7a svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    d: "M16.783 42.63s12.7-4.53 19.263-6.9a3.129 3.129 0 0 1 4.089 2.151l.017.064a3.135 3.135 0 0 1-1.113 3.292l-4 3.084a1.885 1.885 0 0 0 1.718 3.279l16.26-5.2a3.037 3.037 0 0 1 3.762 1.809 3.038 3.038 0 0 1-1.672 3.891l-17.969 8.683a8 8 0 0 1-4.83.683l-15.525-2.657Z",
    className: "colorfecc81 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d5d5d5",
    d: "M11.9 54.5a1 1 0 0 0-1 1v1.426a1 1 0 0 0 2 0V55.5a1 1 0 0 0-1-1Z",
    className: "colorcfd8dc svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a8a8a",
    d: "M45 18.241v-4.482h-2.937A10.241 10.241 0 0 0 40.7 10.47l2.077-2.078-3.169-3.169L37.53 7.3a10.241 10.241 0 0 0-3.289-1.363V3h-4.482v2.937A10.241 10.241 0 0 0 26.47 7.3l-2.078-2.077-3.169 3.169L23.3 10.47a10.241 10.241 0 0 0-1.363 3.289H19v4.482h2.937A10.241 10.241 0 0 0 23.3 21.53l-2.077 2.077 3.169 3.17L26.47 24.7a10.241 10.241 0 0 0 3.289 1.363V29h4.482v-2.937A10.241 10.241 0 0 0 37.53 24.7l2.078 2.077 3.169-3.17L40.7 21.53a10.241 10.241 0 0 0 1.363-3.289Z",
    className: "color78909c svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 16,
    r: 5.687,
    fill: "#ffffff",
    className: "coloredeff0 svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTma);
export default __webpack_public_path__ + "static/media/tma.091ef5d324d1e89fc104e8b745ceca6f.svg";
export { ForwardRef as ReactComponent };